var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.noticeShow)?_c('div',{staticClass:"success-main"},[_c('div',{staticClass:"img-box"},[_c('div',{staticClass:"message-text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"close-button"},[_vm._v("("+_vm._s(_vm.timeNum)+"秒)后关闭")])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }